/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { BookNotepadSpiralIcon16Light } from './BookNotepadSpiralIcon16Light';
import { BookNotepadSpiralIcon16Regular } from './BookNotepadSpiralIcon16Regular';
import { BookNotepadSpiralIcon16Solid } from './BookNotepadSpiralIcon16Solid';
import { BookNotepadSpiralIcon20Light } from './BookNotepadSpiralIcon20Light';
import { BookNotepadSpiralIcon20Regular } from './BookNotepadSpiralIcon20Regular';
import { BookNotepadSpiralIcon20Solid } from './BookNotepadSpiralIcon20Solid';
import { BookNotepadSpiralIcon24Regular } from './BookNotepadSpiralIcon24Regular';
import { BookNotepadSpiralIcon24Solid } from './BookNotepadSpiralIcon24Solid';
import { BookNotepadSpiralIcon32Regular } from './BookNotepadSpiralIcon32Regular';
import { BookNotepadSpiralIcon64Regular } from './BookNotepadSpiralIcon64Regular';
var sizes = {
    16: {
        light: BookNotepadSpiralIcon16Light,
        regular: BookNotepadSpiralIcon16Regular,
        solid: BookNotepadSpiralIcon16Solid,
    },
    20: {
        light: BookNotepadSpiralIcon20Light,
        regular: BookNotepadSpiralIcon20Regular,
        solid: BookNotepadSpiralIcon20Solid,
    },
    24: {
        regular: BookNotepadSpiralIcon24Regular,
        solid: BookNotepadSpiralIcon24Solid,
    },
    32: {
        regular: BookNotepadSpiralIcon32Regular,
    },
    64: {
        regular: BookNotepadSpiralIcon64Regular,
    },
};
export var BookNotepadSpiralIcon = forwardRef('BookNotepadSpiralIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
